import api from '../api'
import Vue from 'vue'

export const DEFAULT_JWT_TOKEN_STORE_KEY = 'auth:jwt:token'

const loadJWTStoredToken = () => {
  return localStorage
    ? (localStorage.getItem(DEFAULT_JWT_TOKEN_STORE_KEY) || '')
    : ''
}

const state = {
  token: loadJWTStoredToken()
}

const actions = {
  doLogin: ({ state, commit }, payload) => {
    return api.apiAuthLogin(payload).then(response => {
      commit('setAccessToken', response.token)
      Vue.http.headers.common['X-Authorization'] = response.token
      return true
    })
  },
  logout: () => {
    localStorage.removeItem(DEFAULT_JWT_TOKEN_STORE_KEY)
  },
  forgotPassword: ({ state, commit }, payload) => {
    return api.apiAuthForgotPassword(payload)
  },
  resetPassword: ({ state, commit }, payload) => {
    return api.apiAuthResetPassword(payload)
  }
}

const mutations = {
  setAccessToken (state, token) {
    if (localStorage) {
      localStorage.setItem(DEFAULT_JWT_TOKEN_STORE_KEY, token || state.token)
    }
    state.token = loadJWTStoredToken()
  }
}

const getters = {
  getAccessToken: state => state.token
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js